import { MapColorTheme, MapColorSlotDefinition } from "@app/shared/map-appearance/interfaces";
import {
  COUNTY_SHADING_MAX_AMETHYST_THEME,
  COUNTY_SHADING_MIN_AMETHYST_THEME,
  COUNTY_SHADING_MAX_AZURE_THEME,
  COUNTY_SHADING_MIN_AZURE_THEME,
  COUNTY_SHADING_MAX_JADE_THEME,
  COUNTY_SHADING_MIN_JADE_THEME,
} from "@app/overviews/market-expansion-dashboard/MarketExpansionDashboardConstants";

export const PROVIDER_LANDSCAPE_COLOR_SLOT_DEFINITIONS: MapColorSlotDefinition[] = [
  { key: "minCaseCountColor", label: "Minimum Case Count" },
  { key: "maxCaseCountColor", label: "Maximum Case Count" },
];

export const PROVIDER_LANDSCAPE_COLOR_THEME_AMETHYST: MapColorTheme = {
  colors: {
    maxCaseCountColor: COUNTY_SHADING_MAX_AMETHYST_THEME,
    minCaseCountColor: COUNTY_SHADING_MIN_AMETHYST_THEME,
  },
  name: "Amethyst",
  uuid: "provider-landscape-amethyst",
};

const PROVIDER_LANDSCAPE_COLOR_THEME_AZURE: MapColorTheme = {
  colors: {
    maxCaseCountColor: COUNTY_SHADING_MAX_AZURE_THEME,
    minCaseCountColor: COUNTY_SHADING_MIN_AZURE_THEME,
  },
  name: "Azure",
  uuid: "provider-landscape-azure",
};

const PROVIDER_LANDSCAPE_COLOR_THEME_JADE: MapColorTheme = {
  colors: {
    maxCaseCountColor: COUNTY_SHADING_MAX_JADE_THEME,
    minCaseCountColor: COUNTY_SHADING_MIN_JADE_THEME,
  },
  name: "Jade",
  uuid: "provider-landscape-jade",
};

export const PROVIDER_LANDSCAPE_PRESET_THEMES: MapColorTheme[] = [
  PROVIDER_LANDSCAPE_COLOR_THEME_AMETHYST,
  PROVIDER_LANDSCAPE_COLOR_THEME_AZURE,
  PROVIDER_LANDSCAPE_COLOR_THEME_JADE
];
